var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"px-5 py-2 rounded-full bg-black text-white text-sm cursor-pointer",on:{"click":_vm.handlerEmbeddedClosePDC}},[_vm._v(" Valider et retourner à ma commande ")])}
var staticRenderFns = []

export { render, staticRenderFns }